/* global ERROR_MSG, RECAPTCHA_SITE_KEY, grecaptcha */
(function app(utils) {
    const { nonce } = window.siteMeta;
    const { testEmail, containsSpecialChars, updateSubmitBtn, qs, qsa, checkNPI, validateRequiredFields, els, updateValidatedField, xuFetch, bootstrapModal } = utils;
    const ELS = {
        ...els,
        formTitle:      qs('#form-title'),
        registerForm:   qs('form#register'),
        enrollBtn:      qs('#enroll-btn'),
        repeatPass:     qs('[name=repeatPassword]'),
        recaptchaField: qs('[name="g-recaptcha-response"]'),
        npiFormGroup:   qs('[data-element="npi-form-group"]'),
        radioNPIStatus: qsa('[name="npiStatus"]'),
    };

    /**
     * Scroll to the form section.
     * @returns {void}
     */
    const scrollToForm = () => ELS.registerForm.scrollIntoView({ behavior: 'smooth', block: 'start' });

    /**
     * Radio buttons for "I have an NPI" and "I don't have an NPI" toggle the NPI field.
     * Hides and shows the NPI field based on the radio button selected.
     * Toggles the required class on the NPI field so the form validation can work.
     * 
     * @returns {void}
     */
    ELS.radioNPIStatus.forEach((radio) => {
        radio.addEventListener('change', () => {
            ELS.npiFormGroup.classList.toggle('d-none');
            ELS.npiField.classList.toggle('d-none');
            ELS.npiField.classList.toggle('required');
        });
    });

    ELS.registerForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const npiVal        = ELS.npiField.value;
        const passVal       = ELS.password.value;
        const repeatPassVal = ELS.repeatPass.value;
        const email         = ELS.email.value;
        const firstName     = ELS.firstName.value;
        const lastName      = ELS.lastName.value;
        const state         = ELS.stateField.value;
        const city          = ELS.cityField.value;

        // Reset recaptcha token.
        ELS.recaptchaField.value = '';

        // Create a recaptcha token.
        grecaptcha.ready(() => grecaptcha.execute(RECAPTCHA_SITE_KEY.siteKey, { action: 'enroll_form_submission' }).then((token) => { ELS.recaptchaField.value = token; }));
        // Wait for the recaptcha token to be created.
        await new Promise((resolve) => {
            const interval = setInterval(
                () => {
                    if (ELS.recaptchaField.value.length > 0) {
                        clearInterval(interval);
                        resolve();
                    }
                },
                10,
            );
        });


        // disable the button state
        updateSubmitBtn('Please wait...', ELS.enrollBtn);

        // Validate required fields.
        let valid = validateRequiredFields(ELS.registerForm);

        // Set the alert if the above produced an error.
        if (!valid){
            updateValidatedField(ELS.formTitle, 'is-invalid', ERROR_MSG.ALL_REQUIRED);
        }

        if (firstName.length === 0) {
            valid = false;
            updateValidatedField(ELS.firstName, 'is-invalid', ERROR_MSG.REQUIRED_FIELD);
        }

        if (lastName.length === 0) {
            valid = false;
            updateValidatedField(ELS.lastName, 'is-invalid', ERROR_MSG.REQUIRED_FIELD);
        }

        if (city.length === 0) {
            valid = false;
            updateValidatedField(ELS.cityField, 'is-invalid', ERROR_MSG.REQUIRED_FIELD);
        }


        if (state.length === 0) {
            valid = false;
            updateValidatedField(ELS.stateField, 'is-invalid', ERROR_MSG.REQUIRED_FIELD);
        }

        // Check for email errors.
        if (email.length ===0) {
            valid = false;
            updateValidatedField(ELS.email, 'is-invalid', ERROR_MSG.REQUIRED_FIELD);
        } else if (!testEmail(email)) {
            valid = false;
            updateValidatedField(ELS.email, 'is-invalid', ERROR_MSG.EMAIL_INVALID);
        }

        if (passVal.length === 0) {
            valid = false;
            updateValidatedField(ELS.password, 'is-invalid', ERROR_MSG.REQUIRED_FIELD);
        }

        if (repeatPassVal.length === 0) {
            valid = false;
            updateValidatedField(ELS.repeatPass, 'is-invalid', ERROR_MSG.REQUIRED_FIELD);
        }

        // Check for valid password.
        if (passVal.length !== 0 || repeatPassVal.length !== 0) {
            if (containsSpecialChars(passVal) === false) {
                updateValidatedField(ELS.password, 'is-invalid', ERROR_MSG.PASS_ERROR);
                valid = false;
            }
            if (passVal !== repeatPassVal) {
                updateValidatedField(ELS.repeatPass, 'is-invalid', ERROR_MSG.PASS_REENTER_NOT_MATCH);
                valid = false;
            }
        }

        // Check for valid NPI.
        if (ELS.npiField.classList.contains('required')) {
            
            if (npiVal.length ===0 ) {
                updateValidatedField(ELS.npiField, 'is-invalid', ERROR_MSG.REQUIRED_FIELD);
                valid = false;
            } else if (npiVal.length !== 10) {
                updateValidatedField(ELS.npiField, 'is-invalid', ERROR_MSG.NPI_INVALID);
                valid = false;
            } else {
                const checkMyNPI = await checkNPI(npiVal);
                if (!checkMyNPI) {
                    updateValidatedField(ELS.npiField, 'is-invalid', ERROR_MSG.NPI_INVALID);
                    valid = false;
                }
            }
        }

        if (valid === false) {
            scrollToForm();
            updateSubmitBtn('__default__', ELS.enrollBtn);
            return;
        }

        xuFetch(
            {
                action:         'register_user_front',
                firstName,
                lastName,
                email,
                recaptchaToken: ELS.recaptchaField.value,
                npi:            npiVal,
                password:       passVal,
                state,
                city,
                _wpnonce:       nonce.registerUserFront,
            },
            (data) => {
                const { data: userID } = data;
                // Open bs modal
                bootstrapModal('#successRegister').show();
                updateSubmitBtn('Success!', ELS.enrollBtn);
                // Set a local storage variable to use later as a "recently registered" check.
                localStorage.setItem('recentlyRegistered', true);
                // Send to GTM
                dataLayer.push({ event: 'user_signup', user_id: userID });
            },
            (error) => {
                const { data: msg } = error;
                if (msg === 'email_exists') {
                    updateValidatedField(ELS.email, 'is-invalid', ERROR_MSG.EMAIL_EXISTS);
                    updateValidatedField(ELS.formTitle, 'is-invalid', ERROR_MSG.ALL_REQUIRED);
                } else if (msg === 'email_domain_banned') {
                    // If the domain is banned, redirect to 404 page.
                    window.location.href = '/404';
                } else if (msg === 'recaptcha_failed') {
                    updateValidatedField(ELS.formTitle, 'is-invalid', ERROR_MSG.RECAPTCHA_FAILED);
                } else {
                    updateValidatedField(ELS.formTitle, 'is-invalid', ERROR_MSG.REQUEST_FAIL);
                }
                updateSubmitBtn('__default__', ELS.enrollBtn);
                scrollToForm();
            },
        );
    });
}(window.utilities));
